import { render, staticRenderFns } from "./FeaturedCategoriesPageTitle.vue?vue&type=template&id=ed73df16&scoped=true"
import script from "./FeaturedCategoriesPageTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeaturedCategoriesPageTitle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FeaturedCategoriesPageTitle.vue?vue&type=style&index=0&id=ed73df16&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed73df16",
  null
  
)

export default component.exports